import { ArrowBack } from "@material-ui/icons";
import { Button, withStyles } from "@material-ui/core";
const styles = (theme) => ({
  actionButton: {
    textTransform: "none",
    "&$actionDisabled": {
      backgroundColor: theme.customInputBGColor,
      color: theme.TextColor,
      cursor: "not-allowed",
      opacity: 0.8,
    },
  },
  actionDisabled: {
    backgroundColor: theme.iconColor,
    color: "black",
  },
});
const BackButton = ({ onClick, disabled, classes }) => (
  <Button
    classes={{ root: classes.actionButton, disabled: classes.actionDisabled }}
    variant="contained"
    color="primary"
    onClick={onClick}
    disabled={disabled}
  >
    <ArrowBack /> Back
  </Button>
);

export default withStyles(styles)(BackButton);
